import { render, staticRenderFns } from "./StaffDelegateVuetifyModal.vue?vue&type=template&id=6d8a4bb7&scoped=true"
import script from "./StaffDelegateVuetifyModal.vue?vue&type=script&lang=js"
export * from "./StaffDelegateVuetifyModal.vue?vue&type=script&lang=js"
import style0 from "./StaffDelegateVuetifyModal.vue?vue&type=style&index=0&id=6d8a4bb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8a4bb7",
  null
  
)

export default component.exports